import React from "react";
import { LanguageCode } from "../../amorg-common";
import { Flex } from "./FlexHelpers";
import { PopupMenuButton, PopupMenuButtonEntry } from "./PopupMenuButton";

type LanguageSelectorProps = {
    availableLanguages:LanguageCode[],
    selectedLanguage:LanguageCode,
    onSelectedLanguageChange:(language:LanguageCode)=>void
}
export function LanguageSelector(props:LanguageSelectorProps):JSX.Element
{
    function getLangText(langCode:LanguageCode)
    {
        function assertHandlerNever(x: never): never {
            throw new Error("Unexpected language: " + x);
        }

        switch(langCode){
            case 'da': return 'Dansk';
            case 'en': return 'English';
            default: assertHandlerNever(langCode);
        }
    }

    function getLanguageMenuItem(languageCode:LanguageCode):PopupMenuButtonEntry
    {
        return {
            type:'menuItem',
            icon:props.selectedLanguage===languageCode ? 'actions_done' : undefined,
            reserveIconSpace:true,
            text:getLangText(languageCode),
            onClick:()=>props.onSelectedLanguageChange(languageCode) 
        };
    }

    return (
        <Flex flexDirection="row" alignItems="center">
            <PopupMenuButton
                buttonText={getLangText(props.selectedLanguage)}
                buttonIcon="language"
                entries={props.availableLanguages.map(al => getLanguageMenuItem(al))}
            />
        </Flex>
    );
}